// TelcoTrack - Development Environment Configuration

import { MAP_ZOOM, MAP_CENTER_CZ } from '../app/shared/constants/map.constants';

// Same-origin API when UI is reached via Docker port / LAN / procesio.xyz (nginx or ng proxy).
// Do NOT reuse this for WMS: relative /wms/ only exists on TLS nginx (procesio.xyz / lenteom),
// not on bare :9041 (LAN IP → Express "Cannot GET /wms/inspire-cp-wms.asp").
const useSameOriginApi =
  globalThis.location.hostname !== 'localhost' && globalThis.location.hostname !== '127.0.0.1'
    ? true
    : globalThis.location.port === '9041';

export const environment = {
  production: false,

  // API: relative in Docker/LAN/procesio.xyz; direct gateway URL only for bare ng serve tooling.
  apiUrl: useSameOriginApi ? '' : 'http://localhost:9045',

  // Performance debug ingest (same-origin via API proxy). Enable locally: performance.enableDebugIngest + ENABLE_DEBUG_INGEST=1.
  debugIngestUrl: `${useSameOriginApi ? '' : 'http://localhost:9045'}/api/debug/ingest/4985f8d7-417a-4dfc-b8b2-470a04bbfd9d`,

  // Backend Services URLs (relative to API Gateway)
  // API Gateway has /api prefix, so full path is /api/{service}/{endpoint}
  authServiceUrl: '/api/auth',
  objectServiceUrl: '/api/objects',
  polygonServiceUrl: '/api/polygons',
  documentServiceUrl: '/api/documents',
  workflowServiceUrl: '/api/workflows',
  notificationsServiceUrl: '/api/notifications',

  // Application Configuration
  app: {
    name: 'TelcoTrack - Status Management',
    version: '1.0.0',
    defaultLanguage: 'cs',
    supportedLanguages: ['cs', 'en'],
    defaultTheme: 'light' as const,
    enableThemeSwitch: true
  },
  
  // Map Configuration (from shared/constants/map.constants)
  maps: {
    defaultCenter: MAP_CENTER_CZ,
    ...MAP_ZOOM,
    tileUrl: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    attribution: '© OpenStreetMap contributors',
    // Always absolute in this DEV file (ng serve / Docker frontend-dev). Production builds use
    // environment.prod.ts relative /wms/… via external nginx. CSP allows https://*.cuzk.gov.cz.
    wmsCadastralUrl: 'https://services.cuzk.gov.cz/wms/inspire-cp-wms.asp',
    // DMVS TI (utility networks) — public WMS allows CORS *; prod uses /wms-dmvs/ via nginx
    wmsDtmTiUrl: 'https://dmvs.cuzk.gov.cz/api/wms/dtm_ti_ver',
  },
  
  // File Upload Configuration
  upload: {
    maxFileSize: 100 * 1024 * 1024, // 100MB
    allowedFileTypes: [
      'image/jpeg',
      'image/png',
      'application/pdf',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    ]
  },
  
  // Logging Configuration
  logging: {
    level: 'debug',
    enableConsoleLogging: true,
    enableRemoteLogging: false
  },
  
  // Performance Configuration
  performance: {
    /** Dev-only: map-perf.ts + perf.interceptor.ts. Keep false in prod builds. */
    enableDebugIngest: false,
    enableServiceWorker: false,
    cacheTimeout: 5 * 60 * 1000, // 5 minutes
    requestTimeout: 30 * 1000, // 30 seconds
    retryAttempts: 3
  }
};
